import React, { useContext } from 'react';
import { Link } from 'react-router-dom'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'; 
import Image from '../images/images1.jpg'; 
import Image2 from '../images/img-cables-wire.jpg';
import Image3 from '../images/img-dairy-products.jpg';
import Image4 from '../images/img-fmeg-electronics.jpg';
import Image5 from '../images/img-formulations-medical-devise.jpg';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import {  faMedapps, faServicestack } from '@fortawesome/free-brands-svg-icons'; 
import { faTags, faTruck } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import HomePageProductCard from '../homePageProductCard/HomePageProductCart';

import './Home.css';
import Reviews from './Reviews';
import Category from '../Category/Category';
import ProductSection from './productInfo/ProductSection';

function Home() {
  const servicesData = [
    {
      title: 'Cables & Wire',
      description: 'Industrial application of Cable & wires.',
      image: Image2,
    },
    {
      title: 'Dairy Products',
      description: 'Dairy plays a significant part in numerous aspects.',
      image: Image3,
    },
    {
      title: 'FMEG & Electronics',
      description: 'FMEG is an emerging sector in India`s current market.',
      image: Image4,
    },
    {
      title: 'Pharmaceutical',
      description: 'Pharma formulation having a wide range of application.',
      image: Image5,
    },
  ];
  const navigate = useNavigate();
 

  return (
    <div>
      {/* Hero Section */}
      <div className="hero-section">
        <div className="hero-content">
          <h1 className="hero-heading">Welcome to A.A. Smart Jet Technology</h1>
          <p className="hero-text">
            Leading provider of innovative printer solutions. Discover our products and services.
          </p>
          <Link to="/about" className="btn btn-primary">Read More</Link>
        </div>
      </div>
      <Category/>
      <ProductSection/>
    
      <section className="section bg-light border-top">
      </section>
      {/* <HomePageProductCard/> */}
{/* Services Section */}
<section className="section bg-light">
  <div className="container">
    <div className="row">
      <div className="col-md-12 mb-4 text-center mt-2">
        <h3 className="main-heading">Our Applications</h3>
        <div className="underline mx-auto"></div>
      </div>
      {servicesData.slice(0, 4).map((service, index) => (
        <div key={index} className="col-md-3 mb-4">
          <div className="card shadow-lg">
            <img src={service.image} alt={service.title} className="card-img-top" />
            <div className="card-body">
              <h5 className="card-title text-center">{service.title}</h5>
              <p className="card-text text-center">{service.description}</p>
            </div>
          </div>
        </div>
      ))}
      <div className="col-12 text-center">
        <Link to="/services" className="btn btn-outline-primary mt-3 mb-3">View All Services &rarr;</Link>
      </div>
    </div>
  </div>
</section>
<br />


      {/* Company Information Section */}
      <div className='section'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12 text-center'>
              <h3 className='main-heading'>Our Company</h3>
              <div className='underline mx-auto'></div>
             
<p>
  With over 5 years of experience, we are a leading manufacturer and supplier of printer machines and parts across commercial and public sectors. 
  <br />
  We offer a wide range of CIJ & TIJ printers and consumables like ink.
</p>
              <Link to="/about" className="btn btn-primary mb-3">Read More</Link>
           
            </div>
          </div>
        </div>
      </div>
      {/* Vision & Mission Section */}
      <section className="vision-mission-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
            <h6 className="text-danger">A.A. Smart Jet Technology</h6>
<h2 className="main-heading">Our Vision & Mission</h2>
<p>
  We ensure timely delivery of all consignments to our customers. Key factors that set us apart in this competitive market include:
</p>
<ul className="vision-list">
  <li>
    <FontAwesomeIcon icon={faCheckCircle} className="icon" />
    OEM-compatible products
  </li>
  <li>
    <FontAwesomeIcon icon={faCheckCircle} className="icon" />
    Advanced in-house quality testing
  </li>
  <li>
    <FontAwesomeIcon icon={faCheckCircle} className="icon" />
    Robust infrastructure
  </li>
</ul>

              <Link to="/about" className="btn btn-primary mt-3">Discover More &rarr;</Link>
            </div>
            <div className="col-md-6">
              <div className="row">
               
                <div className="col-md-6 mb-4">
                  <div className="card shadow">
                    <div className="card-body text-center">
                      <FontAwesomeIcon icon={faTags} className="card-icon" />
                      <h5>REASONABLE PRICES</h5>
                      <p>Discover our products at affordable rates.</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 mb-4">
                  <div className="card shadow">
                    <div className="card-body text-center">
                      <FontAwesomeIcon icon={faTruck} className="card-icon" />
                      <h5>RIGHT TIME DELIVERY</h5>
                      <p>Our company ensures timely delivery of your products.</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 mb-4">
                  <div className="card shadow">
                    <div className="card-body text-center">
                      <FontAwesomeIcon icon={faMedapps} className="card-icon" />
                      <h5>PREMIUM QUALITY PRODUCTS</h5>
                      <p>Discover our products & experience the difference today.</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 mb-4">
                  <div className="card shadow">
                    <div className="card-body text-center">
                      <FontAwesomeIcon icon={faServicestack} className="card-icon" />
                      <h5>PROMPT SPARE & SERVICE SUPPORT</h5>
                      <p>We ensure efficient and reliable assistance for all your needs.</p>
                    </div>
                  </div>
                </div>

             
               
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section bg-light border-top">
      </section>
      <Reviews/>

      {/* Floating WhatsApp Button */}
      <a
        href="https://wa.me/9657579144" // Replace with your WhatsApp number
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FontAwesomeIcon icon={faWhatsapp} className="whatsapp-icon" />
      </a>
    </div>
   
  );
}

export default Home;
